<script>
    import { createEventDispatcher } from "svelte";
    import { HStack, Spacer } from "../component/layout";
    import { update, deleteTeam as del } from "../teams.js";
    import { Button, Label, Hamburger, Text } from "../component/widget";

    export let team;
    export let wedding_guid;
    export let code;

    let cell;

    let isEditTeam = false;
    let name = team.name;
    let current = null;
    let showError = false;
    let errorMessage = null;

    let hamburger = { display: false, opened: false };

    const dispatch = createEventDispatcher();

    const editTeam = (e, team_id) => {
        e.stopPropagation();
        isEditTeam = true;
        hamburger.opened = false;
    };

    let urlBase = window.location.protocol + "//" + window.location.hostname;

    const submitTeam = async () => {
        try {
            showError = false;
            errorMessage = null;
            await update(wedding_guid, team.id, name);
            isEditTeam = false;
            team.name = name;
        } catch (e) {
            showError = true;
            errorMessage = e;
        }
    };

    const deleteTeam = async () => {
        try {
            hamburger.opened = false;
            showError = false;
            errorMessage = null;
            await del(wedding_guid, team.id);
            dispatch("refresh");
        } catch (e) {
            showError = true;
            errorMessage = e;
        }
    };

    const cancel = () => {
        isEditTeam = false;
    };

    const validate = (event) => {};
</script>

<section
    bind:this={cell}
    class="team"
    on:mouseenter={() => (hamburger.display = true)}
    on:mouseleave={() => (hamburger.display = false)}>
    <HStack alignment="center">
        <span class="name">
            <Label icon="images/family-restroom.svg" fa={false} text={team.name} h="auto" />
        </span>
        <Spacer />
        <img
            src={`${urlBase}/api/qrcode/?id=${wedding_guid}&t=${team.id}&c=${code}&p=champiz`}
            alt="Lancer Champiz"
            height="120" />
        <span />
        <a
            href={`${urlBase}/#/champiz/${wedding_guid}?team=${team.id}&code=${code}`}
            target="_blank"
            rel="noopener">Lancer Champiz</a>
        <Spacer />
        <Hamburger bind:open={hamburger.opened} display={hamburger.display} left={false}>
            <Button action={(e) => editTeam(e, team.id)}>
                <Label text="Editer" icon="edit" h="24px" />
            </Button>
            <Button action={(e) => deleteTeam(e, team.id)}>
                <Label text="Supprimer" icon="times-circle" h="24px" />
            </Button>
        </Hamburger>
    </HStack>

    {#if isEditTeam}
        {#if showError}
            <div class="error">Une erreur s'est produite: {errorMessage}</div>
        {/if}
        <form
            class:opened={isEditTeam}
            on:submit|preventDefault={submitTeam}
            on:invalid={validate}
            on:changed={validate}
            on:input={validate}>
            <Text
                id={"name"}
                reset
                required
                bind:value={name}
                icon="fas fa-users"
                label="Nom"
                placeholder="Nom de l'équipe"
                bind:current />

            <HStack>
                <button class="cancel" type="button" on:click={cancel}>
                    <i class="fas fa-angle-double-up" />
                    <span>Annuler</span>
                </button>
                <button class="primary" type="submit">
                    <i class="fas fa-user-plus" />
                    <span>Modifier</span>
                </button>
                <Spacer />
            </HStack>
        </form>
    {/if}
</section>

<style>
    section.team {
        line-height: 3em;
        border: 1px solid var(--primary-color);
        border-radius: 5px;
        padding: 5px;
        margin-bottom: 5px;
    }

    section.team:nth-child(even) {
        background-color: #edf4f9;
    }

    span.name {
        line-height: 1em;
        border-radius: 15px;
        background-color: #b8c5d0;
        padding: 0.5em;
        margin-bottom: 5px;
        margin-right: 1em;
    }

    form {
        margin: 5px;
        border-radius: 15px;
        transform: scaleY(0);
        transform-origin: 50% 0;
        transition: none;
        height: 0;
    }
    form.opened {
        border: 2px solid var(--secondary-light-color);
        padding: 1em;
        transform: scaleY(1);
        transition: transform 0.3s ease-out;
        height: auto;
    }

    button {
        margin-left: 1em;
    }
</style>
